<template>
    <div class="cmui-popup fixed-full" v-show="visible">
        <div class="cmui-popup__mask abs-full" @click="maskClick">
            <slot name="mask"></slot>
        </div>
        <div class="cmui-popup__container abs-full flex-container"
             :class="_position">
            <div class="cmui-popup__content flex-container-col"
                 :style="[_contentStyle,targetStyle]"
                 :class="[targetClass]">
                <div class="cmui-popup__top">
                    <slot name="top"></slot>
                </div>
                <div class="cmui-popup__main flex1 scroll-container-y" ref="main">
                    <slot></slot>
                </div>
                <div class="cmui-popup__bottom">
                    <slot name="bottom"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .cmui-popup {
        z-index: 1000;
    }

    .cmui-popup__mask {
        background-color: rgba(0, 0, 0, .4);
    }

    .cmui-popup__mask:before {
        content: ".";
        display: block;
        width: 1px;
        height: 1px;
        background-color: rgba(0, 0, 0, .1);
        margin-left: -10px;
    }

    .cmui-popup__container {
        pointer-events: none;
    }

    .cmui-popup__content {
        pointer-events: auto;
        background-color: white;
        max-width: 100%;
        max-height: 100%;
    }

    .cmui-popup__top {
        width: 100%
    }

    .cmui-popup__main {
        width: 100%
    }

    .cmui-popup__bottom {
        width: 100%
    }
</style>
<script type="text/javascript">
    let scrollRec;
    export default {
        name: 'popup',
        props: {
            visible: {type: Boolean, default: false},
            maskEvent: {type: Boolean, default: true},
            position: {type: String, default: 'right'},
            targetStyle: {type: Object, default: {}},
            targetClass: Array,
            stopPageScroll: {type: Boolean, default: true}
        },
        methods: {
            maskClick() {
                if (this.maskEvent) {
                    this.visible = false;
                }
            }
        },
        computed: {
            _position() {
                return this.position.match(/(top|right|left|bottom|center)\b/g)
            },
            _contentStyle() {
                let width, height;
                let position = this._position.join(' ')
                switch (position) {
                    case 'top':
                        width = '100%';
                        // height="60%";
                        break;
                    case 'bottom':
                        width = '100%';
                        // height="60%";
                        break;
                    case 'left':
                        height = '100%';
                        width = '80%';
                        break;
                    case 'right':
                        height = '100%';
                        width = '80%';
                        break;
                }
                return {width, height};
            }
        },
        watch: {
            visible: {
                immediate: true,
                handler: function (value) {
                    if (this.stopPageScroll) {
                        if (value) {
                            scrollRec = $(document).scrollTop();
                            document.body.style.top = -scrollRec + 'px';
                            $('body').addClass('fixed-full');
                        } else {
                            document.body.style.removeProperty('top')
                            $('body').removeClass('fixed-full');
                            $(document).scrollTop(scrollRec);
                        }
                    }
                    this.$emit('update:visible', value);
                }
            }
        }
    }
</script>